<div class="wrapper">
  <header class="header">
<mat-toolbar class="header-toolbar">
  <!-- <div>Loblaw</div> -->
  <img   class="logo" src="assets/images/logo.png" alt="logo" />
  <div style="font-size: 14px;" class="mr-auto">
  <div class="font-weight-normal" style="color: white;font-weight: bold;margin-left: 10px">{{'e-Sign' | translate}}</div> 
  <div class="font-weight-normal" style="color: white;margin-top: -8px;margin-left: 10px;">{{'DCN Label' | translate}}</div>
  </div>
  <span class="abs-center hide-xs" style="color: white;">{{'HeaderTitle' | translate}}</span>
  
  <span class="font-weight-normal" style="color: white;">{{'Welcome' | translate}}</span>
  <span class="ml-2" style="color: white;">{{userData.firstName}} {{userData.lastName}}</span>


  
  
</mat-toolbar>

</header>
<app-loader></app-loader>
<main class="content">

<div class="box">
  <div class="box-header"></div>
  <div class="box-body">
    <div class="welcome-container">
      <div class="flex-column-center m-auto p-3">
        <div class="title-xxl font-weight-bold mb-4">
          Electronic Signature Attestation
        </div>
        <p class="mb-4">
          <span
            >I hereby attest that signing Order Confirmations and Receipt Confirmations using my DCN eSign
            username and password is a true representation of my signature.
           </span
          >
          
        </p>
        <div class="title-xxl font-weight-bold mb-4">
          <div class="flex-column-center m-auto p-3">

            ------
            </div>
        </div>

        <div class="title-xxl font-weight-bold mb-4">
          Attestation de signature électronique
        </div>
        <p class="mb-4">
          <span
            >J’atteste par la présente que la signature des confirmations de commande et de réception à l’aide de mon
            nom d'utilisateur et de mon mot de passe du système de signature électronique DCN est une
             représentation fdèle de ma signature.
           </span
          >
          
        </p>

       
        <div class="btn-group">
          <button mat-raised-button color="primary" style="margin: 5px;" (click)="accept()">I Accept/J'accepte</button>
           
          <button mat-raised-button color="warn" style="margin: 5px;" (click)="decline()">I Decline/Je refuse</button>
        </div>
      </div>
    </div>
  </div>
</div>
</main>
<footer class="footer">
  <app-footer></app-footer>
</footer>
</div>

